import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Rol from './components/Rol.vue'
import Usuario from './components/Usuario.vue'
import Cliente from './components/Cliente.vue'
import Documento from './components/Documento.vue'
import Login from './components/Login.vue'
import Socio from './components/Socio.vue'
import Vehiculos from './components/Vehiculos.vue'
import Cambiocontrasenia from './components/Cambiocontrasenia.vue'
import Combustible from './components/Combustible.vue'
import Liquidaciones from './components/Liquidaciones.vue'
import Empresa from './components/Empresa.vue'
import Carpeta from './components/Carpeta.vue'
import Liquida from './components/Liquida.vue'
import Panel from './components/Panel.vue'
import Parametro from './components/Parametro.vue'
import Tad from './components/Tad.vue'
import Flete from './components/Flete.vue'
import Cierredia from './components/Cierredia.vue'
import Credito from './components/Credito.vue'
import Pagocredito from './components/Pagocredito.vue'
import Relacioncredito from './components/Relacioncredito.vue'
import Banco from './components/Banco.vue'
import Isla from './components/Isla.vue'
import Chofer from './components/Chofer.vue'
import Vehiculoqr from './components/Vehiculoqr.vue'
import Barras from './components/Barras.vue'
import Fleteprecio from './components/Fleteprecio.vue'
import Turnonumero from './components/Turnonumero.vue'
import Turno from './components/Turno.vue'
import Calendario from './components/Calendario.vue'
import Expediente from './components/Expediente.vue'
import Arbol from './components/Arbol.vue'
import Voz from './components/Voz.vue'
import Evento from './components/Evento.vue'
import Pipa from './components/Pipa.vue'
import ClientePipa from './components/ClientePipa.vue'

import store from './store' 


Vue.use(Router)

var router= new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    },
    ,
    {
      path: '/socios',
      name: 'socios',
      component: Socio,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    },
    {
      path: '/documentos',
      name: 'documentos',
      component: Documento,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    },
    {
      path: '/roles',
      name: 'roles',
      component: Rol,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/usuarios',
      name: 'usuarios',
      component: Usuario,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/clientes',
      name: 'clientes',
      component: Cliente,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/vehiculos',
      name: 'vehiculos',
      component: Vehiculos,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    },
    {
      path: '/cambiocontrasenias',
      name: 'cambiocontrasenias',
      component: Cambiocontrasenia,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/combustible',
      name: 'combustible',
      component: Combustible,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/liquidaciones',
      name: 'liquidaciones',
      component: Liquidaciones,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/empresa',
      name: 'empresa',
      component: Empresa,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/carpeta',
      name: 'carpeta',
      component: Carpeta,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/liquida',
      name: 'liquida',
      component: Liquida,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/panel',
      name: 'panel',
      component: Panel,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/parametro',
      name: 'parametro',
      component: Parametro,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/tad',
      name: 'tad',
      component: Tad,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/flete',
      name: 'flete',
      component: Flete,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/cierredia',
      name: 'cierredia',
      component: Cierredia,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/credito',
      name: 'credito',
      component: Credito,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/pagocredito',
      name: 'pagocredito',
      component: Pagocredito,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/relacioncredito',
      name: 'relacioncredito',
      component: Relacioncredito,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/banco',
      name: 'banco',
      component: Banco,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/isla',
      name: 'isla',
      component: Isla,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/chofer',
      name: 'chofer',
      component: Chofer,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/vehiculoqr',
      name: 'vehiculoqr',
      component: Vehiculoqr,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/barras',
      name: 'barras',
      component: Barras,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/fleteprecio',
      name: 'fleteprecio',
      component: Fleteprecio,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/turnonumero',
      name: 'turnonumero',
      component: Turnonumero,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/turno',
      name: 'turno',
      component: Turno,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/calendario',
      name: 'calendario',
      component: Calendario,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/expediente',
      name: 'expediente',
      component: Expediente,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/arbol',
      name: 'arbol',
      component: Arbol,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/voz',
      name: 'voz',
      component: Voz,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/evento',
      name: 'evento',
      component: Evento,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/pipa',
      name: 'pipa',
      component: Pipa,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/clientepipa',
      name: 'clientepipa',
      component: ClientePipa,
      meta :{
        administrador :true,
        consulta: true,
        captura: true,
        supervisor: true
      }
    }
    ,
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta : {
        libre: true 
      }
    }
   
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.libre)){
    next()
  } else if (store.state.usuario && store.state.usuario.rol== 'Administrador'){
    if (to.matched.some(record => record.meta.administrador)){
      next()
    }
  }else if (store.state.usuario && store.state.usuario.rol== 'Consulta'){
    if (to.matched.some(record => record.meta.consulta)){
      next()
    }
  }else if (store.state.usuario && store.state.usuario.rol== 'Captura'){
    if (to.matched.some(record => record.meta.captura)){
      next()
    }
  }else if (store.state.usuario && store.state.usuario.rol== 'Supervisor'){
    if (to.matched.some(record => record.meta.supervisor)){
      next()
    }
  } else{
    next({
      name: 'login'
    })
  }
})

export default router
